import styled from 'styled-components';

export const StyledActionsContainer = styled.div`
  margin-top: 50px;
  display: flex;
  justify-content: flex-end;
  gap: 20px;
`;
